// extracted by mini-css-extract-plugin
export default {"breadcrumbLink":"CustomBreadcrumbs_breadcrumbLink__EzMG6"};